const GlobalAlerts = require('global_alerts');

/**
 * Exibir detalhes dos itens contidos dentro
 * de um lote de exportação (Dataul/Pagnet)
 */
function CambioLotes() {
  nifty.body.overlay({
    fixed: true
  });

  applyListeners();
}

/**
 * Adicionar o listener dos botões
 * de detalhes
 *
 * @return {void}
 */
function applyListeners() {
  const buttonsDetails = document.querySelectorAll('[data-cambio-lote]');
  if (buttonsDetails.length) {
    buttonsDetails.forEach((currentButton) => {
      currentButton.addEventListener('click', clickButtonDetails);
    });
  }
}

/**
 * Adicionar o listener das linhas de cambio
 *
 * @return {void}
 */
function applyListenersItens() {
  const trs = document.querySelectorAll('[data-cambio-lote-item]');
  if (trs.length) {
    trs.forEach((currentButton) => {
      currentButton.addEventListener('click', clickButtonDetails);
    });
  }
}
/**
 * Evento do botão de clique para exibir
 * o cambio, disparando uma request para
 * obter o html do conteúdo que será adicionado
 * a modal
 *
 * @param  {Event} event
 */
function clickButtonDetails(event) {
  const button = event.target.dataset.bsTarget ? event.target : event.target.closest('[data-bs-target]');
  const url = button.dataset.cambioUrl;
  const cambioContentClass = button.dataset.cambioContentClass;
  const elModal = document.querySelector(button.dataset.bsTarget);
  const elModalBody = elModal.querySelector(cambioContentClass);

  sendRequest(url)
    .done(function(data) {
      elModalBody.innerHTML = data.data;
      $(elModal).modal('show');
      // aplica evento nas linhas que retornaram
      applyListenersItens();
    })
    .fail(function(error) {
      GlobalAlerts.createAndShow({
        type: 'danger',
        message: error.responseJSON.data
      });
    })
    .always(function() {
      nifty.body.overlay('hide');
    })
}

/**
 * Eventiar a request para obter os dados
 *
 * @param  {string} url
 *
 * @return {Ajax}
 */
function sendRequest(url) {
  return $.ajax({
    method: 'GET',
    url: url
  });
}

module.exports = {
  init: CambioLotes,
  url: /^\/admin\/importacao/,
  applyListeners: applyListeners,
};
